import {isMicroApp} from './env';
import {removeAccessToken, setAccessToken} from '@/util/Token';

type MicroEventBus = {
    on: (event: string, callback: (payload?: any) => void) => () => void;
    emit: (event: string, payload?: any) => void;
};

let offTokenChanged: (() => void) | undefined;
let offLogout: (() => void) | undefined;
let eventBus: MicroEventBus | null = null;

export const notifyTokenExpired = () => {
    if (!isMicroApp()) return;
    eventBus?.emit('auth:token-expired');
};

export const qiankun = {
    async mount(props: any = {}) {
        props.base = '/user/micro/etmf';
        eventBus = props.eventBus;
        const token = props.getToken?.();
        if (token) setAccessToken(token);
        offTokenChanged = props.eventBus?.on?.('auth:token-changed', (token: string) => {
            if (token) setAccessToken(token);
        });
        offLogout = props.eventBus?.on?.('auth:logout', () => {
            removeAccessToken();
        });
    },
    async unmount() {
        offTokenChanged?.();
        offLogout?.();
        offTokenChanged = undefined;
        offLogout = undefined;
        eventBus = null;
        removeAccessToken();
    },
};
